import styled, { css } from 'styled-components';
import { addPxSuffix } from '@/src/helpers';
import { Link } from 'gatsby';

type Props = {
  $disabled?: boolean;
  $underline?: boolean;
  $margin?: string | number;
  $inline?: boolean;
};

const StyledButtonCss = css<Props>`
  width: max-content;
  max-width: 100%;
  text-decoration: none;
  display: ${({ $inline }) => ($inline ? 'inline-flex' : 'flex')};
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  margin: ${({ $margin }) => addPxSuffix($margin ?? 0)};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    &:hover {
      p {
        color: ${({ theme }) => theme.colors.orangePeel};
      }

      svg path {
        fill: ${({ theme }) => theme.colors.orangePeel};
      }
    }
  }
`;

const Button = styled.button<Props>`
  ${StyledButtonCss}
`;

const InternalLink = styled(Link)<Props>`
  ${StyledButtonCss}
`;

const ExternalLink = styled.a<Props>`
  ${StyledButtonCss}
`;

const S = {
  Button,
  InternalLink,
  ExternalLink,
};

export default S;
